import { createApp } from "vue";
import VueGtag from "vue-gtag";
import App from "./App.vue";
import store from "./store";
import Notifications from "@kyvg/vue3-notification";
import "./assets/app.sass";
import router from "./router/router";
import Jazzicon from "vue3-jazzicon/src/components";
import veProgress from "vue-ellipse-progress";
import "@vueform/slider/themes/default.css";

createApp(App)
  .use(store)
  .use(router)
  .use(Notifications)
  .use(veProgress)
  .use(VueGtag, {
    config: { id: "G-SY7SXPRLK9" },
  })
  .component("jazzicon", Jazzicon)
  .mount("#app");
